import { BaseComponent } from "./base.component";

export class Utils extends BaseComponent {
  static loadScript = (
    id: string,
    FILE_URL: string,
    async = true,
    type = "text/javascript"
  ) => {
    return new Promise((resolve, reject) => {
      try {
        const scriptEle = document.createElement("script");
        scriptEle.type = type;
        scriptEle.async = async;
        scriptEle.src = FILE_URL;
        scriptEle.id = id;

        scriptEle.addEventListener("load", (ev) => {
          resolve({ status: true });
        });

        scriptEle.addEventListener("error", (ev) => {
          reject({
            status: false,
            message: `Failed to load the script ＄{FILE_URL}`,
          });
        });

        document.body.appendChild(scriptEle);
      } catch (error) {
        reject(error);
      }
    });
  };

  /**
   * Helper para extraer el ID de un video de YouTube
   */
  static extractYoutubeVideoId(url: string): string | null {
    return BaseComponent.prototype.getYoutubeVideoId(url);
  }
}
